import React, { useEffect, useState } from "react";
import { Grid, TextField, Box, Autocomplete, FormControl, Checkbox } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import DialogBox from "../../global/DialogBox";
import CustomDataGrid from "../../global/CustomDataGrid";
import {
    Button,
    RadioGroup,
    FormControlLabel,
    FormLabel,
    Radio, Typography
} from "@mui/material";
import useAuth from "../../hooks/useAuth";
import {
    AccountingPaidMode,
    AccountingPayStatus,
    CREDIT, DASHBOARD_BASE_URL, DEBIT,
    GET_ACCOUNTING_DATA, NUM_DECIMAL_CHECK_REGEX, PayMedium, SUCCESS, isEmpty, printDebugLog
} from "../../constants/Constants";
import SnpComponent from "../../global/SnpComponent";
import { ACCCREATE, ACCUPDATE, ACCVIEW } from "../../constants/Permissions";


const Accounting = () => {

    const [showDialog, setShowDialog] = useState(false);
    const [edit, setEdit] = useState(false);
    const INITIAL_SNP_COMPONENT = {
        showDialog: false,
        outSideClickDismiss: true,
        title: "",
        subTitle: "",
        negativeAction: "",
        positiveAction: "",
        positiveReq: false,
        iconReq: false,
        iconContent: "",
        snackBarOpen: false,
        snackBarMsg: "",
        cancelExtra: false,
        negativeReq: false,
        requestType: 0,
        handleSnpSubmit: null,
        handleSnpCancel: null,
    };

    const [snpLoader, setSnpLoader] = useState(false);

    const { activeShopHash, authUser, isRoleAllowed } = useAuth();
    const [snpComponent, setSnpComponent] = useState(INITIAL_SNP_COMPONENT);
    const [accountData, setAccountData] = useState([]);
    const INITIAL_ACC_DATA = {
        id: "",
        amount: 0.0,
        userName: "",
        drCr: "",
        message: "",
        mode: 0,
        paidStatus: 0,
        partialAmt: 0.0,
        parentRef: "",
        childRef: "",
        supId: "",
        supName: "",
        stockRefNo: "",
        details: "",
        createdAt: "",
        payMedium: PayMedium.NOT_SELECTED,
        onlinePayThrough: "",
        cashPayThrough: "",
        onlinePay: 0.0,
        cashPay: 0.0,
        entryBy: "",
        duesStr: "",
        dues: 0,
        payCount: "",
        refId: "",
        cgstAmt: 0.0,
        sgstAmt: 0.0,
        isGstAllowed: true,
    }
    const [accSingleData, setSingleAccData] = useState(INITIAL_ACC_DATA);
    const [totalBal, setTotalBalance] = useState(0.0);
    const [totalCashBalance, setTotatCashBal] = useState(0.0);
    const [totalOnlineBalance, setTotalOnlineBal] = useState(0.0);


    useEffect(() => {
        printDebugLog("useEffect Accounting ...");
        firstTimeCall();
    }, []);



    const columns = [
        { field: "createdAt", headerName: "Created At", width: 160 },
        { field: "drCr", headerName: "", width: 50 },
        { field: "amount", headerName: "Full Amt", width: 100 },
        { field: "partialAmt", headerName: "Paid Amt", width: 100 },
        {
            field: "duesStr", headerName: "Dues", width: 150
        },
        { field: "entryBy", headerName: "Entry By", width: 150 },
        { field: "message", headerName: "Msg", width: 200 },
        {
            field: "view",
            headerName: "View",
            width: 80,
            renderCell: (cellValues) => {
                return (
                    <EditIcon
                        sx={{
                            color: "black"
                        }}
                        onClick={(event) => {
                            if (isRoleAllowed(ACCVIEW)) {
                                handleCellClick(event, cellValues);
                            }
                        }}
                    ></EditIcon>
                );
            },
        },
    ];

    const handleCellClick = (param, event) => {
        //console.log("handleCellClick , ", event.row);
        setShowDialog(true);
        setSingleAccData({
            ...accSingleData, ...event.row,
        });
        if (event.row.mode === AccountingPaidMode.MISC) {
            setEdit(false);
        } else {
            setEdit(true);
        }

    };

    const isCashBalanceOk = (cashAmount) => {
        if (cashAmount > totalCashBalance) {
            setSnpComponent(prev => ({
                ...prev, snackBarMsg: "Exceeds Cash balance i.e " + totalOnlineBalance,
                snackBarOpen: true,
            }))
            return false;
        }
        return true
    }

    const isOnlineBalanceOk = (onlineAmount) => {
        if (onlineAmount > totalOnlineBalance) {
            setSnpComponent(prev => ({
                ...prev, snackBarMsg: "Exceeds Online balance i.e " + totalOnlineBalance,
                snackBarOpen: true,
            }))
            return false;
        }
        return true;
    }

    const isTotalBalanceOk = (amount) => {
        if (amount > totalBal) {
            setSnpComponent(prev => ({
                ...prev, snackBarMsg: "Exceeds total balance i.e " + totalBal,
                snackBarOpen: true,
            }))
            return false;
        }
        return true;
    }

    const updateOnlineBalance = (mPayMedium, onlineAmount, payThrough) => {
        const isCashPayEnabled = (mPayMedium === PayMedium.CASH || mPayMedium === PayMedium.BOTH);
        let cash = 0.0;
        if (accSingleData.drCr === DEBIT) {
            if (!isOnlineBalanceOk(onlineAmount)) {
                return;
            }
            if (isCashPayEnabled) {
                cash = accSingleData.amount - onlineAmount;
                if (!isCashBalanceOk(cash)) {
                    return;
                }
            }
        } else {
            if (isCashPayEnabled) {
                cash = accSingleData.amount - onlineAmount;
            }
        }

        setSingleAccData(prev => ({
            ...prev, onlinePay: onlineAmount,
            cashPay: cash,
            payMedium: mPayMedium,
            onlinePayThrough: payThrough,
        }))
    }

    const updateCashBalance = (mPayMedium, cashAmount, payThrough) => {
        const isOnlinePayEnabled = (mPayMedium === PayMedium.ONLINE || mPayMedium === PayMedium.BOTH);
        let online = 0.0;
        if (accSingleData.drCr === DEBIT) {
            if (!isCashBalanceOk(cashAmount)) {
                return;
            }
            if (isOnlinePayEnabled) {
                online = accSingleData.amount - cashAmount;
                if (!isOnlineBalanceOk(online)) {
                    return;
                }
            }
        } else {
            if (isOnlinePayEnabled) {
                online = accSingleData.amount - cashAmount;
            }
        }

        setSingleAccData(prev => ({
            ...prev, onlinePay: online,
            cashPay: cashAmount,
            payMedium: mPayMedium,
            onlinePayThrough: payThrough,
        }))
    }

    const handlePayMedium = (ev) => {
        const name = ev.target.name;
        if (name === 'onlinePayEnb') {
            if (accSingleData.payMedium === PayMedium.NOT_SELECTED) {
                updateOnlineBalance(PayMedium.ONLINE, accSingleData.amount, authUser.onlinePayMethod[0]);
            } else if (accSingleData.payMedium === PayMedium.ONLINE) {
                updateOnlineBalance(PayMedium.NOT_SELECTED, 0.0, "");
            } else if (accSingleData.payMedium === PayMedium.CASH) {
                const onlineAmount = accSingleData.amount - accSingleData.cashPay;
                updateOnlineBalance(PayMedium.BOTH, onlineAmount, authUser.onlinePayMethod[0]);
            } else {
                updateOnlineBalance(PayMedium.CASH, 0.0, "");
            }
        } else if (name === 'cashPayEnb') {
            if (accSingleData.payMedium === PayMedium.NOT_SELECTED) {
                updateCashBalance(PayMedium.CASH, accSingleData.amount, "");
            } else if (accSingleData.payMedium === PayMedium.ONLINE) {
                const cashAmount = accSingleData.amount - accSingleData.onlinePay;
                updateCashBalance(PayMedium.BOTH, cashAmount, accSingleData.onlinePayThrough);
            } else if (accSingleData.payMedium === PayMedium.CASH) {
                updateCashBalance(PayMedium.NOT_SELECTED, 0.0, authUser.onlinePayMethod[0]);
            } else {
                updateCashBalance(PayMedium.ONLINE, 0.0, "");
            }
        }
    }

    const handleOnlineSelectChange = (event, payMethod) => {
        //printLog("handleOnlineSelectChange", payMethod);
        if (payMethod != null) {
            setSingleAccData(prev => ({
                ...prev,
                onlinePayThrough: payMethod,
            }));
        } else {
            setSingleAccData(prev => ({
                ...prev,
                onlinePayThrough: "",
            }));
        }
    };

    const updateValue = (ev, callBack) => {
        const { name, value } = ev.target;
        if (!isEmpty(value)) {
            if (NUM_DECIMAL_CHECK_REGEX.test(value)) {
                const num = Number(value);
                callBack(num);
            }
        } else {
            setSingleAccData(prev => ({
                ...prev, [name]: "",
            }))
        }
    }


    const getAccountingData = async () => {
        try {
            const catgUrl = `${DASHBOARD_BASE_URL}${GET_ACCOUNTING_DATA}`;
            const data = {
                payLoad: {
                    apiToken: authUser.apiToken,
                    shopHash: activeShopHash.id,
                },
            };
            setSnpLoader(true);
            const response = await axios.post(catgUrl, data);
            if (response.data.status === SUCCESS) {
                const payLoad = response.data.payLoad;
                setAccountData(payLoad.data);
                setTotalBalance(payLoad.totalBal ?? 0);
                setTotatCashBal(payLoad.totalCashBalance ?? 0);
                setTotalOnlineBal(payLoad.totalOnlineBalance ?? 0);
            }
        } catch (err) {
            console.error("getAccountingData", err);
        } finally {
            setSnpLoader(false);
        }
    };

    const setAccountingData = async () => {
        try {
            const catgUrl = `${DASHBOARD_BASE_URL}set-accounting-details`;
            const data = {
                payLoad: {
                    apiToken: authUser.apiToken,
                    shopHash: activeShopHash.id,
                    ...accSingleData,
                },
            };
            setSnpLoader(true);
            const response = await axios.post(catgUrl, data);
            if (response.data.status === SUCCESS) {
                getAccountingData();
            }
        } catch (err) {
            console.error("setAccountingData", err);
        } finally {
            setSnpLoader(false);
            handleDialogClose();
        }
    };


    const firstTimeCall = () => {
        getAccountingData();
    };


    const renderDialogContent = () => {
        return (
            <div>
                <Grid container spacing={1} justifyContent="center"
                    alignItems="center" sx={{
                        padding: 0, margin: 0,
                    }}>

                    <Grid item xs={12}>
                        <FormLabel component="legend"
                            sx={{
                                fontSize: "large",
                            }}
                        >Select Mode of Accounting</FormLabel>
                        <RadioGroup row aria-label="mode"
                            size="small"
                            name="mode" value={accSingleData.mode.toString()} onChange={(ev) => {
                                const mode = Number(ev.target.value);
                                setSingleAccData(prev => ({
                                    ...prev, mode: mode,
                                    partialAmt: 0.0, drCr: DEBIT, paidStatus: AccountingPayStatus.ACC_FULL_PAID,
                                }))
                            }} >
                            <FormControlLabel disabled={edit} value={AccountingPaidMode.MISC} control={<Radio />} variant="filled"
                                size="small"
                                label="Miscellaneous Entry"
                            />
                            {
                                accSingleData.mode === AccountingPaidMode.VIASUPPLIER && <FormControlLabel disabled value={AccountingPaidMode.VIASUPPLIER} control={<Radio />} variant="filled"
                                    size="small"
                                    label="Accounting Related to Supplier" />
                            }
                            {
                                accSingleData.mode === AccountingPaidMode.VIABILL &&
                                <FormControlLabel disabled value={AccountingPaidMode.VIABILL} control={<Radio />} variant="filled"
                                    size="small"
                                    label="Accounting Related to Billing" />
                            }

                            {!(authUser.isOwner ?? false) && <FormControlLabel disabled={edit} value={AccountingPaidMode.CLEAR_CASH_BALANCE}
                                control={<Radio />} variant="filled"
                                size="small"
                                label="Clear Cash Balance" />
                            }
                        </RadioGroup>
                    </Grid>

                    <Grid item md={8} sm={8} xs={12} lg={8}>
                        <TextField
                            required
                            id="refId"
                            name="refId"
                            disabled={edit}
                            variant="filled"
                            size="small"
                            label="Bill Ref No"
                            onChange={(ev) => setSingleAccData(prev => ({
                                ...prev, refId: ev.target.value,
                            }))}
                            value={accSingleData.refId}
                            fullWidth
                        />
                    </Grid>

                    <Grid item md={6} sm={6} xs={12} lg={6}>
                        <FormLabel component="legend" sx={{
                            fontSize: "large",
                        }}>Balance Type</FormLabel>
                        <RadioGroup row aria-label="drCr"
                            size="small"
                            name="drCr"
                            onChange={(e) => {
                                setSingleAccData(prev => ({
                                    ...prev, drCr: e.target.value,
                                }))
                            }}
                            value={accSingleData.drCr}>
                            <FormControlLabel disabled={edit} value={DEBIT} control={<Radio />} variant="filled"
                                size="small"
                                label="Debit" />
                            <FormControlLabel disabled={edit
                                || accSingleData.mode === AccountingPaidMode.CLEAR_CASH_BALANCE} value={CREDIT} control={<Radio />} variant="filled"
                                size="small"
                                label="Credit" />
                        </RadioGroup>
                    </Grid>
                    <Grid item md={6} sm={6} xs={12} lg={6}>
                        <FormLabel component="legend" sx={{
                            fontSize: "large",
                        }}>Paid Status</FormLabel>
                        <RadioGroup row aria-label="paidStatus"
                            size="small"
                            name="paidStatus" value={accSingleData.paidStatus}>
                            <FormControlLabel disabled={edit} value={AccountingPayStatus.ACC_FULL_PAID} control={<Radio />} variant="filled"
                                size="small"
                                label="Full Pay" />
                            <FormControlLabel disabled value={AccountingPayStatus.ACC_PARTIAL_PAID} control={<Radio />} variant="filled"
                                size="small"
                                label="Partial Pay" />
                        </RadioGroup>
                    </Grid>
                    <Grid item md={6} sm={6} xs={12} lg={6}>
                        <TextField
                            required
                            id="amount"
                            disabled={edit}
                            name="amount"
                            variant="filled"
                            size="small"
                            label="Amount"
                            fullWidth
                            onChange={(ev) => {
                                updateValue(ev, (num) => {
                                    if (!isTotalBalanceOk(num)) {
                                        return;
                                    }
                                    setSingleAccData(prev => ({
                                        ...prev, amount: num,
                                    }))
                                });
                            }}
                            value={accSingleData.amount}
                        />
                    </Grid>
                    <Grid item md={6} sm={6} xs={12} lg={6}>
                        {
                            (parseInt(accSingleData.paidStatus) === AccountingPayStatus.ACC_PARTIAL_PAID) &&
                            <TextField
                                required
                                id="partialAmt"
                                disabled={edit}
                                name="partialAmt"
                                variant="filled"
                                size="small"
                                label="Partial Amount"
                                fullwidth
                                value={accSingleData.partialAmt}
                            />
                        }
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item md={4} sm={12} xs={12} lg={4}>
                        <FormControl>
                            <FormControlLabel
                                name="isGstAllowed" disabled={edit}
                                control={<Checkbox />}
                                checked={accSingleData.isGstAllowed}
                                onChange={() => {
                                    const gstAllowed = !accSingleData.isGstAllowed;
                                    setSingleAccData(prev => ({
                                        ...prev, isGstAllowed: gstAllowed,
                                        cgstAmt: gstAllowed ? prev.cgstAmt : 0.0,
                                        sgstAmt: gstAllowed ? prev.sgstAmt : 0.0,
                                    }))
                                }}
                                label={accSingleData.isGstAllowed ? "GST is Enable" : "GST is Disable"} />
                        </FormControl>
                    </Grid>
                    <Grid item md={4} sm={12} xs={12} lg={4}>
                        <TextField
                            required
                            id="cgstAmt"
                            name="cgstAmt"
                            variant="filled"
                            disabled={edit || !accSingleData.isGstAllowed}
                            size="small"
                            label="CGST Amount"
                            fullwidth
                            onChange={(ev) =>
                                updateValue(ev, (num) => setSingleAccData(prev => ({
                                    ...prev, cgstAmt: num,
                                })))
                            }
                            value={accSingleData.cgstAmt}
                        />
                    </Grid>

                    <Grid item md={4} sm={12} xs={12} lg={4}>
                        <TextField
                            required
                            id="sgstAmt"
                            name="sgstAmt"
                            variant="filled"
                            disabled={edit || !accSingleData.isGstAllowed}
                            size="small"
                            label="SGST Amount"
                            fullwidth
                            onChange={(ev) =>
                                updateValue(ev, (num) => setSingleAccData(prev => ({
                                    ...prev, sgstAmt: num,
                                })))
                            }
                            value={accSingleData.sgstAmt}
                        />
                    </Grid>

                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={12} sm={12}>
                        <FormLabel id="paymentMethod" sx={{
                            fontSize: "large",
                        }}>Payment Methods:</FormLabel>
                    </Grid >
                    <Grid item xs={12} md={2} sm={6}>
                        <FormControlLabel
                            name="onlinePayEnb"
                            disabled={edit || accSingleData.mode === AccountingPaidMode.CLEAR_CASH_BALANCE}
                            checked={(accSingleData.payMedium === PayMedium.ONLINE || accSingleData.payMedium === PayMedium.BOTH)}
                            onChange={(ev) => handlePayMedium(ev)}
                            control={<Checkbox />}
                            label="Online" />
                    </Grid>
                    <Grid item xs={12} md={5} sm={6}>
                        <Autocomplete
                            id="online-select"
                            options={authUser.onlinePayMethod}
                            autoHighlight
                            variant="filled"
                            disabled={edit}
                            fullWidth
                            size="small"
                            isOptionEqualToValue={(option, value) => option === value}
                            getOptionLabel={(option) => option}
                            defaultValue={accSingleData.onlinePayThrough}
                            onChange={handleOnlineSelectChange}
                            value={accSingleData.onlinePayThrough}
                            renderOption={(props, option) => (
                                <Box
                                    component="li"
                                    {...props}
                                >
                                    {option}
                                </Box>
                            )}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Online Pay Method"
                                    inputProps={{
                                        ...params.inputProps,
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} md={5} sm={6}>
                        <TextField
                            id="onlinePay"
                            name="onlinePay"
                            variant="filled"
                            size="small"
                            disabled={edit || accSingleData.payMedium === PayMedium.NOT_SELECTED || accSingleData.payMedium === PayMedium.CASH}
                            label="Online Amount"
                            onChange={(ev) =>
                                updateValue(ev, (num) => updateOnlineBalance(accSingleData.payMedium, num, accSingleData.onlinePayThrough))
                            }
                            value={accSingleData.onlinePay}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={2} sm={6}>
                        <FormControlLabel name="cashPayEnb"
                            disabled={edit || accSingleData.mode === AccountingPaidMode.CLEAR_CASH_BALANCE}
                            checked={(accSingleData.payMedium === PayMedium.CASH || accSingleData.payMedium === PayMedium.BOTH)}
                            onChange={(ev) => handlePayMedium(ev)}
                            control={<Checkbox />} label="Cash" />
                    </Grid>
                    <Grid item xs={12} md={5} sm={6}>
                        <TextField
                            id="cashPay"
                            name="cashPay"
                            variant="filled"
                            size="small"
                            disabled={edit}
                            label="Cash Amount"
                            onChange={(ev) =>
                                updateValue(ev, (num) => updateCashBalance(accSingleData.payMedium, num, accSingleData.onlinePayThrough))
                            }
                            value={accSingleData.cashPay}
                            fullWidth
                        /> </Grid>
                    <Grid item md={4} sm={5} xs={12}>
                        <TextField
                            id="message"
                            name="message"
                            variant="filled"
                            size="small"
                            rows={3}
                            multiline
                            label="Description"
                            fullWidth
                            onChange={(ev) => setSingleAccData(prev => ({
                                ...prev, message: ev.target.value,
                            }))}
                            value={accSingleData.message}
                        />
                    </Grid>
                </Grid>
                {
                    accSingleData.dues !== 0.0 &&
                    <Grid container spacing={1} justifyContent="center"
                        alignItems="center" sx={{
                            padding: 0, margin: 0,
                        }}>

                        <Grid md={12} sm={12} xs={12} lg={12}>
                            <Typography variant="h5" style={{ color: "#0c1485" }}>
                                {"Remaining Dues: " + accSingleData.dues}
                            </Typography>
                        </Grid>

                    </Grid>
                }
            </div>
        );
    };

    const renderDialogAction = () => {
        return (
            <>

                <Button variant="contained" color="primary" onPointerDown={() => {
                    if (isRoleAllowed(ACCUPDATE)) {
                        setAccountingData();
                    }
                }}>
                    {edit ? "Update" : " Add"}
                </Button>
                <Button variant="contained" color="primary" onPointerDown={() => handleDialogClose()}>
                    Dismiss
                </Button>
            </>
        );
    };



    const handleDialogClose = () => {
        // console.log("handleDialogClose");
        setSingleAccData(INITIAL_ACC_DATA);
        setShowDialog(false);
        setEdit(false);
    };

    const renderSnpContent = () => {
        return (
            <>
                <Grid container spacing={0} display="flex"
                    alignItems="center" sx={{
                        m: 1, p: 2,
                    }}>
                    <Grid item md={4} sm={6} xs={12} lg={4}>
                        <div style={{ padding: 10 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    if (isRoleAllowed(ACCCREATE)) {
                                        setShowDialog(true);
                                    }
                                }}
                            >
                                Add new Entry
                            </Button>
                        </div>
                    </Grid>
                    <Grid item md={12} sm={12} xs={12} lg={12}>
                        <CustomDataGrid
                            title="Bill Accounting Details"
                            getRowId={row => row.id}
                            rows={accountData}
                            columns={columns}
                        />
                    </Grid>
                </Grid>

                <DialogBox
                    showDialog={showDialog}
                    title="View Acccount Entry"
                    onClose={handleDialogClose}
                    dialogContent={renderDialogContent()}
                    dialogActions={renderDialogAction()}
                />
            </>
        );
    };

    return (
        <>
            <SnpComponent showDialog={snpComponent.showDialog}
                title={snpComponent.title}
                isLoader={snpLoader}
                subTitle={snpComponent.subTitle}
                negativeAction={snpComponent.negativeAction}
                positiveReq={snpComponent.positiveReq}
                positiveAction={snpComponent.positiveAction}
                negativeReq={snpComponent.negativeReq}
                iconReq={snpComponent.iconReq}
                iconContent={snpComponent.iconContent}
                content={renderSnpContent()}
                onSnackClose={() => setSnpComponent({
                    ...snpComponent,
                    snackBarOpen: false,
                    snackBarMsg: "",
                })}
                handleSubmit={snpComponent.handleSnpSubmit}
                onCancel={snpComponent.handleSnpCancel}
                cancelExtra={snpComponent.cancelExtra}
                snackBarOpen={snpComponent.snackBarOpen}
                snackBarMsg={snpComponent.snackBarMsg}
                outSideClickDismiss={snpComponent.outSideClickDismiss}
            />
        </>
    );
}

export { Accounting };